Eloca.behaviors.nav = function (context) {
    // Add active state to sidbar nav links
    var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
    $("#layoutSidenav_nav .sb-sidenav a.nav-link", context).each(function () {
        if (this.href === path) {
            $(this).addClass("active");
        }
    });

    // Flag to track manual collapse actions to prevent infinite loops
    // Using window to share state with sidenav-guard.js
    if (!window.manuallyCollapsedSections) {
        window.manuallyCollapsedSections = {};
    }
    var manuallyCollapsedSections = window.manuallyCollapsedSections;

    // Ensure the section that contains the active link stays expanded
    function ensureActiveSectionOpen(ctx) {
        var $activeLinks = $("#layoutSidenav_nav .sb-sidenav a.nav-link.active", ctx);
        $activeLinks.each(function () {
            var $link = $(this);
            // Open closest collapse
            var $collapse = $link.closest('.collapse');
            if ($collapse.length) {
                var collapseId = $collapse.attr('id');
                
                // Don't force open if user manually collapsed this section
                if (collapseId && window.manuallyCollapsedSections[collapseId]) {
                    return;
                }

                // Check if the toggle button indicates manual collapse
                if (collapseId) {
                    var selector = "[data-target='#" + collapseId + "'], a[href='#" + collapseId + "']";
                    var $toggler = $(selector);
                    
                    // If toggler is collapsed and aria-expanded is false, user manually closed it
                    if ($toggler.hasClass('collapsed') && $toggler.attr('aria-expanded') === 'false') {
                        // Don't force open if user manually collapsed
                        return;
                    }
                }

                $collapse.addClass('show');

                // Mark its toggler (if any) as expanded
                if (collapseId) {
                    var selector = "[data-target='#" + collapseId + "'], a[href='#" + collapseId + "']";
                    $(selector).attr('aria-expanded', 'true').removeClass('collapsed');
                }

                // Also open any ancestor collapses
                $collapse.parents('.collapse').addClass('show');
            }
        });
    }
    ensureActiveSectionOpen(context);

    // Listen for manual collapse events to prevent infinite loops
    // Use document instead of context to ensure it works globally
    // Only add if not already added by sidenav-guard.js
    if (!window.sidenavCollapseListenersAdded) {
        $(document).on('hide.bs.collapse', '.sb-sidenav-menu .collapse', function(e) {
            var collapseId = $(this).attr('id');
            if (collapseId) {
                // Mark this section as manually collapsed
                window.manuallyCollapsedSections[collapseId] = true;
                
                // Clear the flag after a delay to allow state to stabilize
                // This prevents the function from forcing it open immediately
                setTimeout(function() {
                    delete window.manuallyCollapsedSections[collapseId];
                }, 500);
            }
        });

        // Listen for manual expand events to clear the flag
        $(document).on('show.bs.collapse', '.sb-sidenav-menu .collapse', function(e) {
            var collapseId = $(this).attr('id');
            if (collapseId && window.manuallyCollapsedSections[collapseId]) {
                // User is manually expanding, clear the flag
                delete window.manuallyCollapsedSections[collapseId];
            }
        });
        
        window.sidenavCollapseListenersAdded = true;
    }

    // Restore sidebar state from localStorage on page load
    var savedSidebarState = localStorage.getItem("layoutSidenav_toggled");
    var hasMinhasOportunidades =
        document.getElementById("minhas-oportunidades") !== null;

    var kanbanModalSemSidenav =
        document.getElementById("layoutSidenav_content") &&
        document
            .getElementById("layoutSidenav_content")
            .classList.contains("kanban-modal-conteudo-cheio");

    if (savedSidebarState === "true") {
        if (hasMinhasOportunidades || kanbanModalSemSidenav) {
            // Do not allow collapsed state when "minhas-oportunidades" is present
            // or iframe/modal kanban sem barra lateral (evita margin-left negativo cortando a tela).
            $("body").removeClass("sb-sidenav-toggled");
            if (hasMinhasOportunidades) {
                localStorage.setItem("layoutSidenav_toggled", "false");
            }
        } else {
            $("body").addClass("sb-sidenav-toggled");
        }
    }
    // After applying saved state, keep the current section expanded
    ensureActiveSectionOpen(context);

    // Toggle the side navigation
    $(".js-sidebar-toggle", context).on("click", function (e) {
        e.preventDefault();

        var isCurrentlyToggled = $("body").hasClass("sb-sidenav-toggled");
        var willCollapse = !isCurrentlyToggled; // toggling would collapse when currently expanded

        if (hasMinhasOportunidades && willCollapse) {
            // Block collapsing when "minhas-oportunidades" is visible in the sidebar
            return;
        }

        $("body").toggleClass("sb-sidenav-toggled");

        // Save sidebar state to localStorage
        var isToggled = $("body").hasClass("sb-sidenav-toggled");
        localStorage.setItem("layoutSidenav_toggled", isToggled);

        // Keep the current active section expanded even after toggle
        ensureActiveSectionOpen(context);
    });

    $(document).on("click", ".js-status-atendimento-item", function (e) {
        var $item = $(this);
        var $menu = $item.closest(".dropdown-menu");
        var url = $menu.data("status-atendimento-url");
        var statusId = $item.data("status-id");

        if (!url || statusId === undefined || statusId === null) {
            return;
        }

        e.preventDefault();

        if ($item.data("loading")) {
            return;
        }

        $item.data("loading", true);

        $.ajax({
            method: "POST",
            url: url,
            data: { status: statusId },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (res) {
                var statusClass = $item.data("status-class") || "text-secondary";
                var statusLabel = $item.data("status-label") || "";

                $("#js-status-atendimento-icon")
                    .removeClass("text-success text-danger text-warning text-secondary")
                    .addClass(statusClass);

                $("#js-status-atendimento-label").text(statusLabel);

                $(".js-status-atendimento-item", $menu).removeClass("active");
                $(".js-status-atendimento-check", $menu).addClass("d-none");
                $item.addClass("active");
                $(".js-status-atendimento-check", $item).removeClass("d-none");

                if (res && res.message && typeof showToastSuccess === "function") {
                    showToastSuccess($("body"), res.message);
                }
            },
            error: function (err) {
                if (typeof showToastDanger === "function") {
                    var msg =
                        (err.responseJSON && err.responseJSON.message) ||
                        "Não foi possível atualizar o status.";
                    showToastDanger($("body"), msg);
                } else {
                    console.error(err);
                }
            },
            complete: function () {
                $item.data("loading", false);
            },
        });
    });
};
